import { useEffect } from "react";
const dirtyForms = new Set();
let loggingOut = false;
export const hasUnsavedChanges = () => dirtyForms.size > 0;
export const isLoggingOut = () => loggingOut;
export const allowLogoutNavigation = () => {
  loggingOut = true;
};
export const useUnsavedChanges = (dirty) => {
  useEffect(() => {
    const form = {};
    if (dirty) dirtyForms.add(form);
    return () => dirtyForms.delete(form);
  }, [dirty]);
};
